App.prototype.megaMenu = function() {
    $('#mega-menu-dropdown').on('show.bs.dropdown', function(){
        $('body').addClass('mega-menu-active');
    });
    $('#mega-menu-dropdown').on('hide.bs.dropdown', function(e){
        $('body').removeClass('mega-menu-active');
    });

    $('.featured-menu .has-sub-menu').mouseenter(function () {
        $('body').addClass('show-menu-overlay');
    });
    $('.featured-menu .has-sub-menu').mouseleave(function () {
        $('body').removeClass('show-menu-overlay');
    });
};


